import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as GoogleTagManagerModule from '@redux-beacon/google-tag-manager';
import {
  authFeatureKey,
  authReducer,
  AuthState,
} from 'src/app/auth/ngrx/auth.reducer';
import { eventsMap } from 'src/app/reducers/tagmanager';
import {
  userFeatureKey,
  userReducer,
  UserState,
} from 'src/app/shared/user/ngrx/user.reducer';
import { createMetaReducer } from 'redux-beacon';

import { environment } from '../../environments/environment';

// Unwrap nested default exports that can occur with CommonJS/ESM interop
function unwrapDefault<T>(module: any): T {
  let result = module;
  while (result && typeof result !== 'function' && result.default) {
    result = result.default;
  }
  return result;
}

export function getMetaReducers(): MetaReducer<State>[] {
  const GoogleTagManager = unwrapDefault<() => any>(GoogleTagManagerModule);
  const gtmMetaReducer = createMetaReducer(eventsMap, GoogleTagManager());
  return [gtmMetaReducer];
}

export interface State {
  [authFeatureKey]: AuthState;
  [userFeatureKey]: UserState;
}

export const reducers: ActionReducerMap<State> = {
  [authFeatureKey]: authReducer,
  [userFeatureKey]: userReducer,
};

export const metaReducers: MetaReducer<State>[] = environment.production
  ? getMetaReducers()
  : [];
